import { create } from "zustand";
import { persist } from "zustand/middleware";

const useNotificationStore = create(
  persist(
    (set) => ({
      orderId: "",
      hasNewNotification: false,
      setOrderId: (newOrderId) => {
        set({ orderId: newOrderId });
      },
      setHasNewNotification: (val) => {
        set({hasNewNotification: val})
      }
    }),
    {
      name: "notification-storage",
      getStorage: () => localStorage,
    }
  )
);

export default useNotificationStore;
